import React from "react";
import { Dialog, DialogActions, Button, DialogTitle, Divider } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { removeRole } from "../../../redux/actions";
import { selectRoles } from "../../../redux/selectors";
import { useReduxStateUpdated } from "../../../hooks/useReduxStateUpdated";
export const GrantAccessDialog = ({ caseId, isOpen, onDialogClose, model, }) => {
    const dispatch = useDispatch();
    const { versionId } = useSelector(selectRoles);
    useReduxStateUpdated(versionId, () => {
        onDialogClose();
    });
    const revert = () => {
        dispatch(removeRole(caseId, model.denialId));
    };
    //const userName = useFieldLookup(usersCachingService, model.id);
    return (React.createElement(Dialog, { open: isOpen, onClose: () => {
            onDialogClose();
        }, maxWidth: "md", fullWidth: true },
        React.createElement(DialogTitle, null,
            "Grant access to ",
            React.createElement("strong", null, model.fullName),
            "?"),
        React.createElement(Divider, null),
        React.createElement(DialogActions, null,
            React.createElement(Button, { onClick: () => onDialogClose(), color: "primary" }, "Close"),
            React.createElement(Button, { onClick: () => revert(), "data-test": "dialog-ok", color: "primary" }, "Ok"))));
};
